export default __webpack_public_path__ + "static/media/leader_notes.ef093c6b.pdf";